/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Step_Hours_PriceInputs */

const en_platform_step_hours_price = /** @type {(inputs: Platform_Step_Hours_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`150 zł`)
};

const pl_platform_step_hours_price = /** @type {(inputs: Platform_Step_Hours_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`150 zł`)
};

/**
* | output |
* | --- |
* | "150 zł" |
*
* @param {Platform_Step_Hours_PriceInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_step_hours_price = /** @type {((inputs?: Platform_Step_Hours_PriceInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Step_Hours_PriceInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_step_hours_price(inputs)
	return en_platform_step_hours_price(inputs)
});